import { configureStore } from '@reduxjs/toolkit';
import categoryReducer from './categorySlice';
import signReducer from './signSlice';
import discourseReducer from './discourseSlice';

const store = configureStore({
  reducer: {
    category: categoryReducer,
    sign: signReducer,
    discourse: discourseReducer,

  },
});

export default store;
